export default {"src":"/_next/static/media/cloud-border.8556bf73.svg","height":72,"width":72,"blurWidth":0,"blurHeight":0};